// api-plugin.js
import { useToast } from "vue-toastification";

export default {
    install: (app) => {
        // Add your API methods to the global Vue instance or provide them as a plugin
        app.config.globalProperties.$toast = useToast();
    }
};